import { styled } from "styled-components";

export const NoProductsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 600px;
  height: 100px;
  border: 1px solid #383838;
  border-radius: 30px;
  margin-bottom: 50px;
  padding: 24px;
`;
